import React from 'react';
import { useTranslation } from 'react-i18next';

import { Message } from '../../../core/components';

// custom error message for the results table
export const ResultsTableNoData: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Message type='empty' title={t('results_order_noFilterMatch')}>
      <div></div>
    </Message>
  );
};
